import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PasswordRecoveryPage from './pages/PasswordRecoveryPage';
import DeviceManager from './components/DeviceManager'; // Direct reference to DeviceManager component
import ResetPasswordPage from './pages/ResetPasswordPage'; // Adjust the path if needed
import DeviceManagerPage from './pages/DeviceManagerPage';
import SingleDevicePage from './pages/SingleDevicePage';
import SettingsPage from './pages/SettingsPage';
import AdminPage from './pages/AdminPage';
import BleWifiPage from './pages/BleWifiPage';
import ChooseScenario from './pages/ChooseScenario';
import AddScenarioPage from './pages/AddScenarioPage';


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/device/:id" element={<SingleDevicePage />} />
                <Route path="/devices" element={<DeviceManagerPage />} />
                <Route path="/password-recovery" element={<PasswordRecoveryPage />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                <Route path="/device-manager" element={<DeviceManagerPage />} />
                <Route path="/settings/:workspaceName/" element={<SettingsPage />} />
                <Route path="/admin-page" element={<AdminPage />} />
                <Route path="/blewifi-page" element={<BleWifiPage />} />
                <Route path="/choose-scenario/:workspaceName" element={<ChooseScenario />} />
                <Route path="/add-scenario/:workspaceName" element={<AddScenarioPage />} />
            </Routes>
        </Router>
    );
}

export default App;
